import { render, staticRenderFns } from "./KintaiLockTag.vue?vue&type=template&id=02a8338c&scoped=true&"
import script from "./KintaiLockTag.vue?vue&type=script&lang=ts&"
export * from "./KintaiLockTag.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02a8338c",
  null
  
)

export default component.exports